// Settlement for Ultimate v4 "Match Script" picks (schema_version 4).
// Returns true/false for v4 picks, or undefined for older picks so callers fall
// through to their legacy logic (whose majority-vote fallback would misjudge v4 picks).
export function settleUltimateV4(prediction, homeGoals, awayGoals) {
  if (!prediction || prediction.schema_version !== 4) return undefined;
  switch (prediction.primary_pick) {
    case 'btts': return homeGoals > 0 && awayGoals > 0;
    case 'over25': return homeGoals + awayGoals >= 3;
    case 'draw': return homeGoals === awayGoals;
    case 'outcome':
      if (prediction.prediction === 'H') return homeGoals > awayGoals;
      if (prediction.prediction === 'A') return awayGoals > homeGoals;
      return false;
    default: return false;
  }
}
